import { render } from "./modal-task.vue?vue&type=template&id=d34029f0&scoped=true"
import script from "./modal-task.vue?vue&type=script&lang=js"
export * from "./modal-task.vue?vue&type=script&lang=js"

import "./modal-task.vue?vue&type=style&index=0&id=d34029f0&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34029f0"]])

export default __exports__